import makeValidationSchema from './OgaCodeMakeValidationSchema'
import { components, useTranslation } from 'cng-web-lib'
import React from 'react'
import Namespace from 'src/constants/locale/Namespace'
import ProductMasterKeys from 'src/constants/locale/key/SbciProductMaster'
import { Grid } from '@material-ui/core'
import { useFormContext } from 'react-hook-form'

const {
  form: {
    field: { CngTextField, CngCodeMasterAutocompleteField }
  },
  CngGridItem
} = components

const DEFAULT_INITIAL_VALUES = Object.freeze({
  ogaCode: '',
  ogaDocNo: ''
})

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES },
  makeValidationSchema: makeValidationSchema
}

function Fields({ index, disabled, shouldHideMap }) {
  const { setValue, getValues } = useFormContext()
  const { translate } = useTranslation(Namespace.SBCI_PRODUCT_MASTER)
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    const ogaCode = translate(
      Namespace.SBCI_PRODUCT_MASTER,
      ProductMasterKeys.OgaCode.TITLE
    )
    const ogaDocNo = translate(
      Namespace.SBCI_PRODUCT_MASTER,
      ProductMasterKeys.OgaCode.OGA_DOC_NO
    )

    return { ogaCode, ogaDocNo }
  }

  return (
    <Grid container spacing={1}>
      <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap?.ogaCode}>
        <CngCodeMasterAutocompleteField
          codeType='SBCI_OGA_CODE'
          name={typeof index === 'number' ? `ogaInfo.${index}.ogaCode` : 'ogaCode'}
          label={translatedTextsObject.ogaCode}
          disabled={disabled}
          onChange={(_, option) =>
            setValue(typeof index === 'number' ? `ogaInfo.${index}.ogaCode` : 'ogaCode', option ? option.value : '', {shouldValidate:true})
          }
          required
          size='small'
          key={getValues(`ogaInfo.${index}.ogaCode`)}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap?.ogaDocNo}>
        <CngTextField
          name={typeof index === 'number' ? `ogaInfo.${index}.ogaDocNo` : 'ogaDocNo'}
          label={translatedTextsObject.ogaDocNo}
          disabled={disabled}
          onChange={(event) =>
            setValue(typeof index === 'number' ? `ogaInfo.${index}.ogaDocNo` : 'ogaDocNo', event.target.value.toUpperCase(), {shouldValidate:true})
          }
          required
          size='small'
        />
      </CngGridItem>
    </Grid>
  )
}

const OgaCodeFormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields
})

export default OgaCodeFormProperties
